import React from 'react';
import ComingSoon from '../../pages/v2/ComingSoon';

/**
 * FeatureGate (V2)
 * Single source of truth for build-time feature gating of a route's content.
 * When `enabled` is true the real page (`children`) renders; when it's false a
 * <ComingSoon> placeholder titled `title` renders instead.
 *
 * The caller still owns the auth check and the <LayoutV2> wrapper — this
 * component only decides real-page-vs-placeholder. Keeping that decision in one
 * tiny module-scope component (rather than inline ternaries in App's route JSX)
 * makes it unit-testable in isolation and collapses the otherwise-duplicated
 * gating block repeated across the maintenance and 3D-model routes.
 *
 * `enabled` comes from the build-time FEATURES object (see featureFlags.js); it
 * is a constant for the lifetime of a session, so this never causes a remount.
 */
const FeatureGate = ({ enabled, title, children }) =>
    enabled ? children : <ComingSoon title={title} />;

export default FeatureGate;
